import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VisuallyHiddenUsage from './VisuallyHiddenUsage';
import ClientProvider from './client';
export default createDemo(import.meta.url, VisuallyHiddenUsage, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/screen-readers/demos/visually-hidden-usage/VisuallyHiddenUsage.tsx",
    "fileName": "VisuallyHiddenUsage.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Link from '@mui/material/Link';\nimport Box from '@mui/material/Box';\nimport { visuallyHidden } from '@mui/utils';\n\nexport default function VisuallyHiddenUsage() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Link href=\"#foo\">\n      Read more\n      {/* always visually hidden because the parent is focusable element */}\n      <Box sx={visuallyHidden}>about how to visually hide elements</Box>\n    </Link>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 13,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Link from '@mui/material/Link';\nimport Box from '@mui/material/Box';\nimport { visuallyHidden } from '@mui/utils';\n\nexport default function VisuallyHiddenUsage() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Link href=\"#foo\">\n      Read more\n      {/* always visually hidden because the parent is focusable element */}\n      <Box sx={visuallyHidden}>about how to visually hide elements</Box>\n    </Link>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "#foo",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            "      Read more"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c",
                "/* always visually hidden because the parent is focusable element */"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "visuallyHidden"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">about how to visually hide elements</",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 13,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/Link",
      "@mui/material/Box",
      "@mui/utils"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
